import { AtlasRouteIds } from '@/components/navigation/constants';
import { FeatureFlagSet } from '@/types';

/**
 * Simple mapping of routes to their feature flags.
 * When a flag is:
 * - true: Gaia handles the feature
 * - false: Redirect to Darkwing
 *
 * These flags are managed in LaunchDarkly and control the gradual
 * migration of features from Darkwing to Gaia.
 */
export const ROUTE_FEATURE_FLAGS: Record<string, keyof FeatureFlagSet> = {
  [AtlasRouteIds.CoincidentPeaks]: 'gaia-synthetic-readings',
  [AtlasRouteIds.CompressorSequencer]: 'gen-4-equipment-browser',
  [AtlasRouteIds.CondenserSequencer]: 'gen-4-equipment-browser',
  [AtlasRouteIds.DemandEvents]: 'gaia-synthetic-readings',
  [AtlasRouteIds.Equipment]: 'gen-4-equipment-browser',
  [AtlasRouteIds.FacilityPerformance]: 'gaia-synthetic-readings',
  [AtlasRouteIds.Map]: 'gaia-facility-map',
  [AtlasRouteIds.ProcessView]: 'gaia-process',
  [AtlasRouteIds.System]: 'gen-4-equipment-browser',
  // Add more routes as they are migrated
} as const;

/**
 * Checks if a route has a feature flag configured.
 * @param value - The route identifier to check
 * @returns The feature flag key if configured, false otherwise
 */
export const hasRouteFeatureFlag = (value: string) =>
  (value && ROUTE_FEATURE_FLAGS[value]) ?? false;
